import { useState, useEffect } from 'react';
import axios from 'axios';
import { getAppCheckHeaders } from '../firebase';

const useSubscriptionProducts = () => {
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [error, setError] = useState(null);
  const API_BACKEND = process.env.REACT_APP_SHOPKEEP_BACKEND || 'http://localhost:3001';

  useEffect(() => {
    const fetchSubscriptionProducts = async () => {
      try {
        const headers = await getAppCheckHeaders();
        const response = await axios.get(`${API_BACKEND}/api/subscriptionProducts`, { headers });

        if (response.data.success && response.data.data && Array.isArray(response.data.data.products)) {
          const transformedPlans = response.data.data.products.map((product) => ({
            id: product.id,
            stripePriceId: product.stripePriceId,
            name: product.name,
            price: `$${product.price}`,
            period: product.periodUnit || product.period,
            description: product.overview,
            features: product.settings
              .filter((setting) => setting.showInCta)
              .map((setting) => setting.desc),
            cta: 'Start Free Trial',
            highlighted: product.planHighlighted,
            trialPeriodDays: product.trialPeriodDays,
          }));

          setPlans(transformedPlans);
          setError(null);
        } else {
          setError('Invalid data structure received from API');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch subscription products');
      } finally {
        setLoadingPlans(false);
      }
    };

    fetchSubscriptionProducts();
  }, [API_BACKEND]);

  return { plans, loadingPlans, error };
};

export default useSubscriptionProducts;
